// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-AqT1aj","root":"root-P9EwlY","submit":"submit-e_IFCC","list":"list-uTp3g4","label":"label-gRCQ36","notExist":"notExist-mhxn0x"};